import React from 'react'


const CirclePlus = (props) =>
    <svg {...props}
         xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 24 24">
        <path d="M20.484 20.485A11.916 11.916 0 0 1 12 24a11.916 11.916 0 0 1-8.484-3.515A11.915 11.915 0 0 1 0 12c0-3.205 1.248-6.218 3.516-8.485A11.919 11.919 0 0 1 12 0a11.92 11.92 0 0 1 8.485 3.516A11.92 11.92 0 0 1 24 12a11.92 11.92 0 0 1-3.516 8.485zM19.07 4.93A9.927 9.927 0 0 0 12 2a9.927 9.927 0 0 0-7.07 2.93A9.929 9.929 0 0 0 2 12a9.93 9.93 0 0 0 2.93 7.071A9.93 9.93 0 0 0 12 22a9.93 9.93 0 0 0 7.07-2.929A9.935 9.935 0 0 0 22 12a9.933 9.933 0 0 0-2.93-7.07zM17 13h-4v4a1 1 0 0 1-2 0v-4H7a1 1 0 0 1 0-2h4V7a1 1 0 0 1 2 0v4h4a1 1 0 0 1 0 2z" fillRule="evenodd"/>
    </svg>

export default CirclePlus


// WEBPACK FOOTER //
// ./src/components/_common/_icons/CirclePlus.js